import React, { useContext } from "react";
export var CollapsibleListContext = React.createContext(undefined);
export function useCollapsibleListContext() {
    var c = useContext(CollapsibleListContext);
    return c;
}
